<template>
  <div
    @keydown.esc="closeSignUpPpup"
    ref="signUpPopup"
    class="lite-lp-popup lite-lp-popup-signup-overlay"
    id="signup-overlay"
    tabindex="0"
  >
    <div class="lite-lp-popup-content lite-lp-signup-popup">
      <header class="popup-header">
        <a
          class="lite-lp-popup-close"
          id="close-signup"
          @click="closeSignUpPpup"
        ></a>
        <h2 class="lite-lp-popup-title">
          {{ $t("CREATE_ACCOUNT") }}
        </h2>
      </header>
      <section class="popup-main-content" :class="{ 'after-login': loading }">
        <div class="wrap">
       <div class="login-buttons-wrap">
           <sso-header></sso-header>
        </div>
          <form class="lite-lp-signup-popup-form" id="registerForm" name="registerForm" @submit="register($event)"
                autocomplete="off">
            <div class="input-container">
              <div
                class="input-wrap"
                :class="{ error: $v.user.private_name.$error }"
              >
                <div class="input-design">
                  <input
                    type="text"
                    :placeholder="$t('FIRST_NAME')"
                    v-model="user.private_name"
                    class="lite-lp-popup-input"
                    @input="$v.user.private_name.$touch()"
                  />
                </div>
                <span class="error-text">
                  {{ $t("FIRST_NAME_MISSING") }}
                </span>
              </div>
              <div
                class="input-wrap"
                :class="{ error: $v.user.family_name.$error }"
              >
                <div class="input-design">
                  <input
                    type="text"
                    :placeholder="$t('LAST_NAME')"
                    v-model="user.family_name"
                    class="lite-lp-popup-input"
                    @input="$v.user.family_name.$touch()"
                  />
                </div>
                <span class="error-text">
                  {{ $t("LAST_NAME_MISSING") }}
                </span>
              </div>
            </div>
            <div class="input-container">
              <div
                class="input-wrap"
                :class="{ error: $v.user.institution.$error }"
              >
                <div class="input-design">
                  <input
                    type="text"
                    :placeholder="$t('INSTITUTION')"
                    v-model="user.institution"
                    class="lite-lp-popup-input"
                    @input="$v.user.institution.$touch()"
                  />
                </div>
                <span class="error-text">
                  {{ $t("INSTITUTION_MISSING") }}
                </span>
              </div>
              <div
                v-if="originOfClient === 'IL'"
                class="input-wrap"
                :class="{ error: $v.user.city.$error }"
              >
                <div class="input-design">
                  <input
                    type="text"
                    :placeholder="$t('CITY')"
                    v-model="user.city"
                    class="lite-lp-popup-input"
                    @input="$v.user.city.$touch()"
                  />
                </div>
                <span class="error-text">
                  {{ $t("CITY_MISSING") }}
                </span>
              </div>
              <div
                v-if="!(originOfClient === 'IL')"
                class="input-wrap"
                :class="{ error: $v.user.country.$error }"
              >
                <div class="input-design">
                  <input
                    type="text"
                    :placeholder="$t('COUNTRY')"
                    v-model="user.country"
                    class="lite-lp-popup-input"
                    @input="$v.user.country.$touch()"
                  />
                </div>
                <span class="error-text">
                  {{ $t("COUNTRY_MISSING") }}
                </span>
              </div>
            </div>
            <div class="input-wrap" :class="{ error: $v.user.email.$error || responseError.email }">
              <div class="input-design">
                <input
                  type="email"
                  :placeholder="$t('EMAIL')"
                  v-model="user.email"
                  class="lite-lp-popup-input"
                  @input="$v.user.email.$touch(); responseError.email = null; responseError.general = null"
                />
              </div>
              <span class="error-text" v-if="!$v.user.email.required">
                {{ $t("EMAIL_MISSING") }}
              </span>
              <span
                class="error-text"
                v-if="$v.user.email.required && !$v.user.email.email"
              >
                {{ $t("EMAIL_INVALID") }}
              </span>
              <span class="error-text"
                v-if="responseError.email"
              >
                {{ $t(responseError.email) }}
              </span>
            </div>
            <div class="input-wrap" :class="{ error: $v.user.username.$error || responseError.username }">
              <div class="input-design">
                <input
                  type="text"
                  :placeholder="$t('NAME')"
                  v-model="user.username"
                  class="lite-lp-popup-input"
                  autocomplete="off"
                  @input="$v.user.username.$touch(); responseError.username = null; responseError.general = null"
                />
              </div>
              <span class="error-text" v-if="!$v.user.email.required">
                {{ $t("USERNAME_MISSING") }}
              </span>
              <span class="error-text"
                v-if="responseError.username"
              >
                {{ $t(responseError.username) }}
              </span>
            </div>
            <div class="input-wrap" :class="{ error: $v.user.password.$error || responseError.password}">
              <div class="input-design">
                <input
                  :type="showPassword ? 'text' : 'password'"
                  :placeholder="$t('PASSWORD')"
                  v-model="user.password"
                  class="lite-lp-popup-input"
                  autocomplete="off"
                  @input="$v.user.password.$touch(); responseError.password = null"
                />
                <span @click="showPassword = !showPassword">
                  <img v-if="!showPassword" class="show-password-eye" src="@/assets/images/eye_show_password.svg" alt="icon">
                  <img v-else class="show-password-eye" src="@/assets/images/eye_show_password_hide.svg" alt="icon">
                </span>
              </div>
              <span class="error-text" v-if="$v.user.password.$error">
                {{ $t(passwordErrorText) }}
              </span>
              <span class="error-text" v-if="responseError.password">
                {{ $t(responseError.password) }}
              </span>
            </div>
            <span class="password-details" v-html="$t('PASSWORD_RULES')"></span>
            <div>
             <div class="captcha" v-if="showCaptcha">
               <vue-hcaptcha :sitekey="siteKey" @verify="verifyCaptcha"></vue-hcaptcha>
             </div>
            </div>
            <button
              type="submit"
              class="lite-lp-popup-submit"
              :disabled="checkIfHasNullFile"
            >
              {{ $t("LOGIN") }}
            </button>
            <span
              v-if="responseError.general"
              class="error-text"
              style="text-align: center; display: block"
            >
              {{ $t(responseError.general) }}
            </span>
          </form>
        </div>
      </section>
      <div class="loader-login"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SsoHeader from '@/components/sso-header'
import config from '@/config.js'
import { required, requiredIf, email, minLength, maxLength } from 'vuelidate/lib/validators'
import VueHcaptcha from '@hcaptcha/vue-hcaptcha'

export default {
  name: 'sign-up-popup',
  components: { SsoHeader, VueHcaptcha },
  data: function () {
    return {
      user: {
        email: null,
        password: null,
        username: null,
        private_name: null,
        family_name: null,
        institution: null,
        city: null,
        country: null
      },
      passwordInvalidText: null,
      showPassword: false,
      responseError: {
        password: null,
        email: null,
        username: null,
        general: null
      },
      siteKey: process.env.VUE_APP_HCAPTCHA_SITE_KEY,
      catpchaToken: null
    }
  },
  validations: {
    user: {
      private_name: {
        required
      },
      family_name: {
        required
      },
      institution: {
        required
      },
      city: {
        required: requiredIf(function () {
          return this.originOfClient === 'IL'
        })
      },
      country: {
        required: requiredIf(function () {
          return !(this.originOfClient === 'IL')
        })
      },
      email: {
        required,
        email
      },
      username: {
        required
      },
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(16),
        containsUppercase: function (value) {
          return /[A-Z]/.test(value)
        },
        containsLowercase: function (value) {
          return /[a-z]/.test(value)
        },
        containsNumber: function (value) {
          return /[0-9]/.test(value)
        },
        isOnlyEnglishLetters: function (value) {
          return /^[\x20-\x7E]*$/.test(value)
        }
      }
    }
  },

  computed: {
    showCaptcha () {
      return process.env.VUE_APP_SHOW_CAPTCHA === 'true'
    },
    getSitekey () {
      switch (window.location.hostname) {
        case 'test.classe.world':
        case 'localhost':
        case 'test-3.classe.world':
        case '127.0.0.1':
        case 'web':
        case 'nginx':
          // Use test key which doesn't require recpatcha
          return '6LeOWUMUAAAAAFcIeux22vdwWXMM8dGXUbSoVIbo'
        default:
          return '6LeOWUMUAAAAAFcIeux22vdwWXMM8dGXUbSoVIbo'
      }
    },
    ...mapState({
      originOfClient: state => state.base.originOfClient,
      lang: state => state.base.lang.localName,
      loading: state => state.base.popupLoading
    }),

    checkIfHasNullFile () {
      let flag = false
      for (const key in this.user) {
        if (this.$v.user[key].$error || !this.$v.user[key].required) {
          flag = true
        }
      }
      // TODO: fix when can check recaptcha - if recaptcha fails keeps showing error
      //   if (!this.recaptchaResponse) { flag = true }
      return flag
    },
    passwordErrorText () {
      if (!this.$v.user.password.required) {
        return ('PASSWORD_MISSING')
      } else if (!this.$v.user.password.isOnlyEnglishLetters) {
        return ('PASSWORD_LETTERS_MUST_BE_IN_ENGLISH_ONLY')
      } else if (!this.$v.user.password.minLength || !this.$v.user.password.maxLength) {
        return ('PASSWORD_MUST_BE_BETWEEN_8_AND_16_CHARACTERS_LONG')
      } else if (!this.$v.user.password.containsLowercase) {
        return ('PASSWORD_MUST_CONTAIN_LOWERCASE_LETTER')
      } else if (!this.$v.user.password.containsUppercase) {
        return ('PASSWORD_MUST_CONTAIN_UPPERCASE_LETTER')
      } else if (!this.$v.user.password.containsNumber) {
        return ('PASSWORD_MUST_CONTAIN_NUMBER')
      }
      return (null)
    }
  },

  methods: {
    closeSignUpPpup () {
      this.$router.push({ name: 'logIn' })
    },
    verifyCaptcha (response) {
      this.catpchaToken = response
    },
    register: function (e) {
      e.preventDefault() // to prevent reload
      this.$store.dispatch('setPopupLoading', true)
      const newUser = {
        userName: this.user.username,
        email: this.user.email.toLowerCase(),
        pass: this.user.password,
        privateName: this.user.private_name,
        famelyName: this.user.family_name,
        lang: this.lang,
        brithday: null,
        phone: null,
        country: this.user.country,
        city: this.user.city,
        institution: this.user.institution,
        school: null,
        ...(this.showCaptcha && { captcha: this.catpchaToken })
      }
      this.$store.dispatch('signUp', newUser)
        // calls function in store to set up new user, if users data is good sends back new user with JWT.
        // else sends back what data is problematic for new user to be set up
        .then((response) => {
          const data = response.data
          if (response.data.access_token) {
            config.setToken(response.data.access_token)
            this.$store.dispatch('setUserData', data.user)
            localStorage.setItem('jwt', data.access_token)
            localStorage.setItem('user', JSON.stringify(data.user))
            this.$store.dispatch('getLibrary', this.$route.params.librarySlug).then(() => {
              this.$store.dispatch('getAllLibraries').then(() => {
                this.$store.dispatch('getRoles', this.$route.params.librarySlug)
                this.$store.dispatch('setPopupLoading', false)
                const self = this
                this.$store.dispatch('goCollectionEntryDirect').then(function (res) {
                  if (res) return
                  self.$router.push({ name: 'baseLibrary' })
                })
              })
            }).catch(() => {
              // If the library is blocked
              // go to error page
              this.$router.push({ name: 'unauthorizedUser' })
            })
          } else if (typeof data.res.err !== 'undefined') {
            this.$store.dispatch('setPopupLoading', false)
          } else {
            this.$store.dispatch('setPopupLoading', false)
          }
        }).catch((error) => {
          this.$store.dispatch('setPopupLoading', false)
          this.showSignupResponseError(error.response.data)
        })
    },
    showSignupResponseError (errorsArray) {
      for (const error in errorsArray) {
        const feildOfError = error
        let errorText = errorsArray[error][0]
        if (feildOfError === 'password1') {
          if (errorText === 'This password is too common.') this.responseError.password = 'PASSWORD_IS_TO_COMMON'
          else this.responseError.password = 'PROBLEM_WITH_PASSWORD'
        } else if (feildOfError === 'email') {
          if (errorText === 'A user is already registered with this e-mail address.') this.responseError.email = 'EMAIL_USED_BY_OTHER_USER'
          else this.responseError.email = 'PROBLEM_WITH_EMAIL'
        } else if (feildOfError === 'username') {
          if (errorText === 'A user with that username already exists.') this.responseError.username = 'USERNAME_ALREADY_EXISTS'
          else this.responseError.username = 'PROBLEM_WITH_USERNAME'
        } else if (feildOfError === 'detail') {
          errorText = errorsArray[error]
          if (errorText === 'This user already exists in Classe') {
            this.responseError.general = 'USERNAME_OR_PASSWORD_ALREADY_USED'
          } else this.responseError.general = 'PROBLEM_WITH_SIGNUP_TRY_LATER'
        } else {
          if (errorText === 'The password is too similar to the username.') this.responseError.password = 'PASSWORD_IS_TO_SIMILER_TO_USERNAME'
          else {
            this.responseError.general = 'PROBLEM_WITH_SIGNUP_TRY_LATER'
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .show-password-eye{
    width: 23px;
    cursor: pointer;
  }
</style>
